// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1183":"e13ee71f","2204":"bc96b468"}[chunkId] + ".chunk.css";
};